import { Injectable } from "@angular/core";
import { Firestore, collection, query, collectionData, where, CollectionReference, doc, updateDoc } from "@angular/fire/firestore";
import { Router } from "@angular/router";
import { IUserNotification, NotificationType, TableType } from "@soposopo/sopo-models";
import { Subscription } from "rxjs";
import { distinctUntilChanged} from "rxjs/operators";
import { ApiService } from "src/app/core/backend/api.service";
import { GameStoreDispatcher } from "src/app/core/state/game/game.dispatcher";
import { GameToLoad } from "src/app/core/state/game/game.state";
import { FireSubService } from "src/app/core/firebase/fireSub.service";
import { SopoPopupService } from "src/app/sopo-popup/service/sopo-popup.service";
import { SopoConfirmSettings } from "src/app/sopo-popup/interfaces/confirm";

@Injectable({ providedIn: 'root' })
export class NotificationService{
    userId: string;
    notificationSubscription: Subscription;
    oneSecond = 1000;

    constructor(
        private firestore: Firestore,
        private apiService: ApiService,
        private router: Router,
        private gameDispatcher: GameStoreDispatcher,
        private fireSubService: FireSubService,
        private sopoPopupService: SopoPopupService,
    ){}

    public async notificationSubscribe(userId: string) {
        this.userId = userId;

        const dateNowSeconds = new Date(Date.now());
        dateNowSeconds.setMilliseconds(dateNowSeconds.getMilliseconds() - 1);

        const collectionRef = collection(this.firestore, `users/${this.userId}/notifications`) as CollectionReference<IUserNotificationAndDocId>;
        const collectionQuery = query(collectionRef,
            where('read', '==', false),
            where('expiryDate', ">" , dateNowSeconds)
        );
        const data = collectionData<IUserNotificationAndDocId>(collectionQuery, {idField: 'reviewDocId'}).pipe(distinctUntilChanged());
        this.notificationSubscription = data.subscribe(notifications => {

            const waitingListNotification = notifications.filter(notification => notification.type === NotificationType.waitingList);

            if (waitingListNotification.length > 0) {

                for (const notification of waitingListNotification) {

                    const toNav = !this.router.url.includes('/game');
                    const options: SopoConfirmSettings = {
                        data: {
                            header: `Waiting List`,
                            body: notification.payload.message,
                        },
                        sCss: ['sopo-popup-red-background'],
                    };
                    this.sopoPopupService
                    .promptForConfirmation('app', options)
                        .then( async (confirmation) => {
                            const seconds = Math.round(Date.now()) + (this.oneSecond * 10);
                            if (confirmation) {
                                const game: GameToLoad = {
                                    componentType: 'game',
                                    gameStateId: notification.payload.tableId,
                                    tableId: notification.payload.tableId,
                                    clubId: notification.payload.clubId,
                                    tournamentId: '',
                                    type: TableType.RING
                                };
                                this.gameDispatcher.addNewGame(game, toNav, false, { toBeSeated: true, seatId: notification.payload.emptySeatIndex });
                            }
                            if (!confirmation && (notification.payload.timeout > seconds)){
                                this.apiService.leaveWaitingList({userID: notification.userId, tableID: notification.payload.tableId}, notification.payload.gameServerUrl);                   
                            }
                        })

                    this.setNotificationRead(notification.reviewDocId);
                }
            }

        })
        this.fireSubService.registerSubscription(this.notificationSubscription);

    }

    private async setNotificationRead(reviewDocId: string) {
        const docRef = doc(this.firestore, `users/${this.userId}/notifications/${reviewDocId}`);
        await updateDoc(docRef, {read: true})
    }

    public notificationUnsubscribe() {
        if (this.notificationSubscription) this.notificationSubscription.unsubscribe();
    }

}

interface IUserNotificationAndDocId extends IUserNotification {
    reviewDocId: string;
}
